import { selectConfigurationState } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

import { collectSobDataDependsOnSettings } from '../helpers/collectSobDataDependsOnSettings'

import { selectCompetitorsSobState } from './selectCompetitorsSobState'

export const selectCompetitorsSobData = createSelector(
  [selectCompetitorsSobState, selectConfigurationState],
  ({ data }, { programType, actualsType, currency }) => {
    const sobCompetitors = data[programType] || []

    return collectSobDataDependsOnSettings({
      sobCompetitors,
      netNdp: actualsType,
      currency,
    })
  }
)
